/**
 * The two `localStorage` keys that somebody other than their owner has to name.
 *
 * Both belong to a module `lib/auth.ts` cannot import. `lib/compose.ts` reaches
 * the daemon through `lib/jmap.ts`, which imports `authState`, so an import the
 * other way would close a cycle; `lib/tabs.ts` is reachable, but its key sits
 * beside this one because the pair is cleared by the same three lines and split
 * constants are how one of them gets missed.
 *
 * Signing out clears both -- see `forgetThisMachine` in `lib/auth.ts` -- and
 * that is the whole reason this file exists. A second spelling of a key is not
 * a compile error and not a test failure: the sweep simply removes a key nobody
 * writes, and the one that is actually on the disk stays there, holding a
 * message body in plaintext under an origin the next person at this machine
 * will also open.
 *
 * Nothing else moves here. A key only one module names is that module's
 * business and reads better where it is used.
 */

/** `lib/compose.ts`: the composer's crash guard. Message text, in the clear. */
export const MIRROR_KEY = "hm.compose.mirror";

/** `lib/tabs.ts`: the addresses of the messages that were open. */
export const TABS_KEY = "hm.tabs";
